import { AccountStreaks, FetchError } from "@decibeltrade/sdk";
import { type FetchQueryOptions, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";

// Account streaks query

export interface AccountStreaksQueryArgs {
  ownerAddr: string | undefined;
}

export function accountStreaksQueryKey({ ownerAddr }: AccountStreaksQueryArgs) {
  return ["accountStreaks", ownerAddr] as const;
}

export const PLACEHOLDER_ACCOUNT_STREAKS: AccountStreaks = {
  owner: "",
  currentStreak: 0,
  streakIpoints: 0,
  streakAmpsEstimate: 0,
  graceDaysAvailable: 0,
  graceDaysUsed: 0,
  qualifyingDates: [],
};

export function accountStreaksQuery({ ownerAddr }: AccountStreaksQueryArgs) {
  return {
    queryKey: accountStreaksQueryKey({ ownerAddr }),
    queryFn: async () => {
      if (!ownerAddr) return PLACEHOLDER_ACCOUNT_STREAKS;

      try {
        return await readDexSdk.streaks.getByOwner({ ownerAddr });
      } catch (error) {
        if (error instanceof FetchError && error.status === 404) {
          return PLACEHOLDER_ACCOUNT_STREAKS;
        }
        throw error;
      }
    },
    retry(failureCount: number, error: Error) {
      if (error instanceof FetchError && error.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
  } satisfies FetchQueryOptions<AccountStreaks>;
}

export function useAccountStreaksQuery(args: AccountStreaksQueryArgs) {
  return useQuery({
    ...accountStreaksQuery(args),
    enabled: !!args.ownerAddr,
  });
}
